import { Component, OnInit } from '@angular/core';
import { ClassedViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-hotelreservations',
    templateUrl: './hotelreservations.component.html',
    styleUrls: ['./hotelreservations.component.scss'],
    standalone: false
})
export class HotelreservationsComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }

  public Subsets: string[] = ['PendingStaffApproval', 'Active', 'Cancelled', 'Expired'];

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Guest", "GuestName"),
    new Datalistviewcolumn("Room Number", "GuestRoomNumber"),
    new Datalistviewcolumn("Plate Number", "GuestPlateNumber"),
    new Datalistviewcolumn("Start Date", "StartDateLocalFriendlyString"),
    new Datalistviewcolumn("End Date", "EndDateLocalFriendlyString"),
    new Datalistviewcolumn("Group", "ParkingPermitTypeName"),
    new ClassedViewColumn("Status", "CurrentStateName")
  ];
}


